import { Link } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/movies', label: '电影库' },
  { to: '/news', label: '影视资讯' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

const genreLinks = ['剧情', '爱情', '悬疑', '犯罪', '文艺', '科幻'];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16 md:mt-24">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="brand-font text-xl text-background-50">聚会的目的电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              专注电影剧情解读、专业影评与影视资讯的内容平台。我们围绕电影《聚会的目的》及其相关作品，
              为影迷提供深入的剧情分析、真实的观点碰撞与及时的行业动态。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 tracking-wide">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 tracking-wide">热门分类</h3>
            <ul className="mt-4 space-y-2.5">
              {genreLinks.map((g) => (
                <li key={g}>
                  <Link
                    to={`/movies?genre=${encodeURIComponent(g)}`}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors"
                  >
                    {g}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70 text-center sm:text-left">
            © {new Date().getFullYear()} 聚会的目的电影 · 本站内容为演示用途，影视数据均为虚构
          </p>
          <p className="text-xs text-background-200/70">
            影迷交流信箱：hello@juhuidemudi.example.com
          </p>
        </div>
      </div>
    </footer>
  );
}